import * as React from 'react';
import styled, { css } from 'styled-components';

import { cssDeclaration } from '../../../_ThemeTwo_/Utils/Styles/cssDeclaration';

import { TaskInstruction } from './TaskCardInstruction';
import { ITaskCardProps, StatusType } from './common';
import { TaskCardAlert } from './TaskCardAlert';
import { VerTask } from './TaskCardContent';
import { TaskThumb } from './TaskCardThumb';
import { TaskIcon } from './TaskCardIcon';
import { TaskCardContain } from './TaskCardContain';
import { VerTaskTitle } from './TaskCardTitle';
import { VerTaskHeadline } from './TaskCardHeadline';
import { TaskCardNotification } from './TaskCardNotification';
import { VerTaskBlurb } from './TaskCardBlurb';
import VerTaskCardCta from './VerTaskCardCta';

const TaskCardHeadline = styled(VerTaskHeadline)<{status?: StatusType}>`
  ${({ theme: { taskCard, themeTwo }}) => !status && taskCard.header && css`
    color: ${taskCard.header.color && taskCard.header.color.incomplete};
    line-height: ${taskCard.header.lineHeight && taskCard.header.lineHeight};

    ${taskCard.header.margin && cssDeclaration(themeTwo, 'margin', taskCard.header.margin)};
    ${taskCard.header.font && taskCard.header.font.size && cssDeclaration(themeTwo, 'font-size', taskCard.header.font.size)};
  `}
`;

export class TaskCard extends React.PureComponent<ITaskCardProps> {
  public static defaultProps: Partial<ITaskCardProps> = {
    status: 'none',
    forceAccessible: false
  };

  public render () {
    const {
      icon,
      blurb,
      blurbs,
      title,
      alert,
      notification,
      status,
      children,
      forceAccessible,
      preventCompleteColor,
      ...rest
    } = this.props;
    const [inReview, isComplete] = [status === 'review', status === 'complete'];

    return (
      <TaskCardContain
        inReview={inReview}
        isComplete={isComplete}
        preventCompleteColor={preventCompleteColor}
        {...rest}
      >
        {!!alert && <TaskCardAlert>{alert}</TaskCardAlert>}
        <VerTask>
          { icon && (
            <TaskThumb inReview={inReview} isComplete={isComplete} preventCompleteColor={preventCompleteColor}>
              <TaskIcon icon={icon} />
            </TaskThumb>
          )}
          <TaskInstruction>
            <VerTaskTitle>
              <TaskCardHeadline scale='small' as='h2' status={status}>
                {title}
              </TaskCardHeadline>
              <TaskCardNotification notification={notification} status={status} />
            </VerTaskTitle>
            {!!blurb && <VerTaskBlurb isComplete={isComplete || inReview}>{blurb}</VerTaskBlurb>}
            {
              !!blurbs && blurbs.map((blrb, idx) =>
                <VerTaskBlurb key={`blurb-${idx}`} isComplete={isComplete || inReview}>{blrb}</VerTaskBlurb>)
            }
          </TaskInstruction>
          {(preventCompleteColor || forceAccessible || !(isComplete || inReview)) && (
            <VerTaskCardCta />
          )}
        </VerTask>
        {children}
      </TaskCardContain>
    );
  }
}

export default TaskCard;
